<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="germplasm-list-search-tab">
	<div class="d-flex">
		<jhi-column-filter [request]="request" [resultSearch]="resultSearch" [filters]="filters" [eventName]="COLUMN_FILTER_EVENT_NAME"
						   class="flex-sm-grow-1"></jhi-column-filter>
	</div>
	<br/>
	<div class="row">
		<div class="col">
			<div ngbDropdown class="float-end" placement="bottom-right">
				<button class="btn btn-info" id="actionMenu" data-test="actionMenu" ngbDropdownToggle *jhiHasAnyAuthority="ACTION_BUTTON_PERMISSIONS" jhiTranslate="actions"></button>
				<div ngbDropdownMenu aria-labelledby="actionMenu">
					<button class="dropdown-item" type="submit"  *jhiHasAnyAuthority="IMPORT_GERMPLASM_LIST_PERMISSION" jhiTranslate="germplasm-list.actions.import-list"
							data-test="importListButton"
							[routerLink]="['/', { outlets: { popup: 'germplasm-list-import'} }]"
							[replaceUrl]="true"
							queryParamsHandling="merge">
					</button>
				</div>
			</div>
			<div class="mb-3 d-flex align-items-center">
				<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
				<div class="ms-2">
					<button class="btn btn-outline-info btn-sm" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
				</div>
				<span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
			</div>
		</div>
	</div>
	<br/>
	<div class="table-responsive" *ngIf="germplasmLists">
		<table class="table table-striped table-bordered table-curved" *ngIf="germplasmLists.length else nodata" data-test="germplasmListSearchTable">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
				<th [jhiSortBy]="ColumnLabels.LIST_NAME"><span jhiTranslate="germplasm-list.search.columns.list-name"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.PARENT_FOLDER"><span jhiTranslate="germplasm-list.search.columns.parent-folder"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.DESCRIPTION"><span jhiTranslate="germplasm-list.search.columns.description"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.LIST_OWNER"><span jhiTranslate="germplasm-list.search.columns.list-owner"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.LIST_TYPE"><span jhiTranslate="germplasm-list.search.columns.list-type"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.NUMBER_OF_ENTRIES"><span jhiTranslate="germplasm-list.search.columns.number-of-entries"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.LOCKED"><span jhiTranslate="germplasm-list.search.columns.locked"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.NOTES"><span jhiTranslate="germplasm-list.search.columns.notes"></span> <span class="fa fa-sort"></span></th>
				<th [jhiSortBy]="ColumnLabels.CREATION_DATE"><span jhiTranslate="germplasm-list.search.columns.list-date"></span> <span class="fa fa-sort"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let list of germplasmLists; trackBy: trackId; index as index">
				<td><a href (click)="selectList($event, list)">{{list.listName}}</a></td>
				<td>{{list.parentFolderName}}</td>
				<td><span class="text-ellipsis" title="{{list.description}}">{{list.description}}</span></td>
				<td>{{list.listOwner}}</td>
				<td>{{list.listType}}</td>
				<td>{{list.numberOfEntries}}</td>
				<td>{{list.locked ? 'Yes' : 'No'}}</td>
				<td><span class="text-ellipsis" title="{{list.notes}}">{{list.notes}}</span></td>
				<td>{{list.creationDate ? list.creationDate : 'null'}}</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>
	<div *ngIf="germplasmLists && germplasmLists.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
